import { gql } from "@apollo/client";

export const RESET_USER_PASSWORD_MUTATION = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

export const LOGOUT_USER_MUTATION = gql`
  mutation LogoutUser {
    logoutUser
  }
`;

export const LOGIN_USER_MUTATION = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      user {
        _id
        id
        name
        email
      }
      token
    }
  }
`;

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser(
    $_id: String!
    $email: String
    $password: String
    $name: String
  ) {
    updateContact(_id: $_id, email: $email, password: $password, name: $name) {
      _id
      id
      name
      email
    }
  }
`;
